const emerging = {
    emergingArtists: "Emerging Artists",
    artists: "Artists",
    numberWorks: "Number of Works",
    artistComments:	"Artist's Comments",
}

module.exports = emerging;